import {useEffect} from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import htmlIcon from '../assets/imgs/html5.png';
import cssIcon from '../assets/imgs/css3.png';
import bootstrapIcon from '../assets/imgs/bootstrap.png';
import talwindIcon from '../assets/imgs/talwind.png';
import jsIcon from '../assets/imgs/javascript.png';
import reactIcon from '../assets/imgs/react-tech.png';
import tsIcon from '../assets/imgs/typescript.png';
import render from '../assets/imgs/render.png';
import githubIcon from '../assets/imgs/github.png';
import gitIcon from '../assets/imgs/git.png';
import netlify from '../assets/imgs/netlify.png';
import sublimeIcon from '../assets/imgs/sublime.png';
import vscodeIcon from '../assets/imgs/vsCode.png';
import canvaIcon from '../assets/imgs/canva.png';
import mongoIcon from '../assets/imgs/mongoDb.png';
import nodeIcon from '../assets/imgs/node.png';
import mysqlIcon from '../assets/imgs/mysql.png';
import postmanIcon from '../assets/imgs/postman.png';

const TechStack = () => {

  useEffect(() => {
    AOS.init({
      duration: 1500,
      once: true,
    });
  },[]);

  const techTooltips = {
    HTML5: "Semantic structure for web pages",
    CSS3: "Modern styling with Flexbox and Grid",
    JavaScript: "Logic and interactivity",
    TypeScript: "Typed JavaScript for scalable applications",
    "React.js": "SPA development with components",
    Tailwind: "Utility-first CSS framework",
    Bootstrap: "Fast layout design with components",
    "Node.js": "Backend JavaScript runtime",
    MongoDB: "NoSQL document database",
    MySQL: "Relational DBMS",
    Git: "Version control system",
    GitHub: "Code hosting and collaboration platform",
    Postman: "API testing tool",
    VSCode: "Powerful code editor",
    Sublime: "Lightweight code editor",
    Canva: "Graphics and content design",
    Netlify: "Frontend hosting and deployment platform",
    Render: "Cloud platform for backend deployment"
  };


  return (
    <section className="section mb-0 bg-light" id="techstack">
      <div className="container text-center">
        <p className="section-subtitle"  data-aos="fade-right">Tools I Work With</p>
        <h6 className="section-title mb-6"  data-aos="fade-right">Tech Stack</h6>

        <div className="row justify-content-center"  data-aos="fade-right">
          <div className="col-4 col-md-2 mb-4 skill-tooltip">
            <img src={htmlIcon} alt="HTML5" className="tech-img" />
            <span className='tooltip-text'>{techTooltips["HTML5"]}</span>  
          </div> 
          <div className="col-4 col-md-2 mb-4 skill-tooltip">
            <img src={cssIcon} alt="CSS3" className="tech-img" />  
            <span className='tooltip-text'>{techTooltips["CSS3"]}</span> 
          </div> 
          <div className="col-4 col-md-2 mb-4 skill-tooltip">
            <img src={jsIcon} alt="JavaScript" className="tech-img" /> 
            <span className='tooltip-text'>{techTooltips["JavaScript"]}</span>  
          </div>  
          <div className="col-4 col-md-2 skill-tooltip">
            <img src={tsIcon} alt="TypeScript" className="tech-img" />  
            <span className='tooltip-text'>{techTooltips["TypeScript"]}</span> 
          </div>
          <div className="col-4 col-md-2 mb-4 skill-tooltip">
            <img src={reactIcon} alt="React.js" className="tech-img" />
            <span className='tooltip-text'>{techTooltips["React.js"]}</span>   
          </div>
          <div className="col-4 col-md-2 mb-4 skill-tooltip">
            <img src={talwindIcon} alt="Tailwind" className="tech-img" />
            <span className='tooltip-text'>{techTooltips["Tailwind"]}</span>   
          </div>
          <div className="col-4 col-md-2 mb-4 skill-tooltip">
            <img src={bootstrapIcon} alt="Bootstrap" className="tech-img" /> 
            <span className='tooltip-text'>{techTooltips["Bootstrap"]}</span>  
          </div> 
          <div className="col-4 col-md-2 mb-4 skill-tooltip">
            <img src={nodeIcon} alt="Node.js" className="tech-img" />
            <span className='tooltip-text'>{techTooltips["Node.js"]}</span>   
          </div> 
          <div className="col-4 col-md-2 mb-4 skill-tooltip">
            <img src={mongoIcon} alt="MongoDB" className="tech-img" />
            <span className='tooltip-text'>{techTooltips["MongoDB"]}</span>   
          </div> 
          <div className="col-4 col-md-2 mb-4 skill-tooltip">
            <img src={mysqlIcon} alt="MySQL" className="tech-img" />
            <span className='tooltip-text'>{techTooltips["MySQL"]}</span>   
          </div>
          <div className="col-4 col-md-2 skill-tooltip">
            <img src={gitIcon} alt="Git" className="tech-img" />  
            <span className='tooltip-text'>{techTooltips["Git"]}</span> 
          </div>
          <div className="col-4 col-md-2 mb-4 skill-tooltip">
            <img src={githubIcon} alt="Postman" className="tech-img" />
            <span className='tooltip-text'>{techTooltips["GitHub"]}</span>   
          </div>
          <div className="col-4 col-md-2 mb-4 skill-tooltip">
            <img src={postmanIcon} alt="Postman" className="tech-img" />
            <span className='tooltip-text'>{techTooltips["Postman"]}</span>   
          </div>
          <div className="col-4 col-md-2 mb-4 skill-tooltip">
            <img src={vscodeIcon} alt="VSCode" className="tech-img" />
            <span className='tooltip-text'>{techTooltips["VSCode"]}</span>   
          </div>
          <div className="col-4 col-md-2 mb-4 skill-tooltip">
            <img src={sublimeIcon} alt="Sublime" className="tech-img" />
            <span className='tooltip-text'>{techTooltips["Sublime"]}</span>   
          </div>
          <div className="col-4 col-md-2 mb-4 skill-tooltip">
            <img src={canvaIcon} alt="Canva" className="tech-img" />
            <span className='tooltip-text'>{techTooltips["Canva"]}</span>   
          </div>
          <div className="col-4 col-md-2 mb-4 skill-tooltip">
            <img src={netlify} alt="Netlify" className="tech-img" />
            <span className='tooltip-text'>{techTooltips["Netlify"]}</span>   
          </div>
          <div className="col-4 col-md-2 skill-tooltip">
            <img src={render} alt="Render" className="tech-img" />  
            <span className='tooltip-text'>{techTooltips["Render"]}</span> 
          </div>
        </div>
      </div>
    </section>
  );
};

export default TechStack;
